//D=1 I=2 S=3 C=4
function calcDISC(x,y){
    //if two D’s: show this detail:
    if(x===1 && y===1){
       return 0;
   }
   //if two I’s: show this detail:
   else if(x===2 && y===2){
       return 1;
   }
   //if two S’s: show this detail:
   else if(x===3 && y===3){
       return 2;
   }
   //if two C’s: show this detail:
   else if(x===4 && y===4){
       return 3;
   }
   //If S’s and I: show this detail:
   else if((x===3 && y===2) || (x===2 && y===3)){
       return 4;
   }
   //If C’s and I: show this detail: 
   else if((x===4 && y===2) || (x===2 && y===4)){
       return 5;
   }
   //If C’s and S: show this detail: 
   else if((x===4 && y===3) || (x===3 && y===4)){
       return 6;
   }
   //If D and C, show this detail:
   else if((x===1 && y===4) || (x===4 && y===1)){
       return 7;
   }
   //If D and I, show this detail:
   else if((x===1 && y===2) || (x===2 && y===1)){
       return 8;
   }
     //If D and S, show this detail:
     else if((x===1 && y===3) || (x===3 && y===1)){
       return 9;
   }
}

export {calcDISC}
